/* istanbul ignore file - better tested visually */

import { classNames } from '@partful/shared/lib/classNames';
import { ComponentProps, forwardRef } from 'react';
import styles from './ProgressBar.module.scss';

type ProgressBarProps = ComponentProps<'div'> & {
  value?: number;
  max?: number;
};

export const ProgressBar = forwardRef<HTMLDivElement, Readonly<ProgressBarProps>>(
  ({ value, max, children, ...props }, ref) => {
    const safeValue = Math.max(0, value ?? 0);
    const safeMax = Math.max(1, max ?? 1);

    return (
      <div
        className={classNames(styles.track)}
        {...props}
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={safeMax}
        aria-valuenow={value && safeValue}
        data-value={value && safeValue}
        ref={ref}
      >
        <div style={{ width: value && `${(safeValue / safeMax) * 100}%` }} className={styles.value} />
      </div>
    );
  }
);
